import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import Transition from "../../stateless/Transition";
import AddAccesoryToInventory from "../inventory/additions/AddAccesoryToInventory";

const AddAccesoryStockModal = ({
  open,
  onClose,
  detailProduct,
  detailProduct: { accesoryId, brand, model },
  stockAdded,
  isNewStock,
}) => {
  console.log("isNewStock", isNewStock);
  return (
    <Dialog
      open={open}
      maxWidth={"sm"}
      onClose={onClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <AddAccesoryToInventory
          detailProduct={detailProduct}
          isNewStock={isNewStock}
          accesoriesCreated={stockAdded}
        />
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(AddAccesoryStockModal);
